import axios from '@/libs/api.request'


export const getSincerityList = async (that, data) => {
    if (typeof window.localStorage['overallShopToken'] != 'undefined' && window.localStorage['overallShopToken'] != '') {
        data.token = window.localStorage['overallShopToken'];
    }
    var res = await axios.request({
        url: '/shop/finance/getSincerityList',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return;
    }
    return res;
}
export const sureSincerity = async (that, data) => {
    if (typeof window.localStorage['overallShopToken'] != 'undefined' && window.localStorage['overallShopToken'] != '') {
        data.token = window.localStorage['overallShopToken'];
    }
    var res = await axios.request({
        url: '/shop/finance/sureSincerity',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return;
    }
    return res;
}
export const sureSincerityDeal = async (that, data) => {
    if (typeof window.localStorage['overallShopToken'] != 'undefined' && window.localStorage['overallShopToken'] != '') {
        data.token = window.localStorage['overallShopToken'];
    }
    var res = await axios.request({
        url: '/shop/finance/sureSincerityDeal',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return;
    }
    return res;
}
export const getContractList = async (that, data) => {
    if (typeof window.localStorage['overallShopToken'] != 'undefined' && window.localStorage['overallShopToken'] != '') {
        data.token = window.localStorage['overallShopToken'];
    }
    var res = await axios.request({
        url: '/shop/finance/getContractList',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return;
    }
    return res;
}
export const passContract = async (that, data) => {
    if (typeof window.localStorage['overallShopToken'] != 'undefined' && window.localStorage['overallShopToken'] != '') {
        data.token = window.localStorage['overallShopToken'];
    }
    var res = await axios.request({
        url: '/shop/finance/passContract',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return;
    }
    return res;
}
export const refuseContract = async (that, data) => {
    if (typeof window.localStorage['overallShopToken'] != 'undefined' && window.localStorage['overallShopToken'] != '') {
        data.token = window.localStorage['overallShopToken'];
    }
    var res = await axios.request({
        url: '/shop/finance/refuseContract',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return;
    }
    return res;
}
export const getRepaymentList = async (that, data) => {
    if (typeof window.localStorage['overallShopToken'] != 'undefined' && window.localStorage['overallShopToken'] != '') {
        data.token = window.localStorage['overallShopToken'];
    }
    var res = await axios.request({
        url: '/shop/finance/getRepaymentList',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return;
    }
    return res;
}
export const passRepayment = async (that, data) => {
    if (typeof window.localStorage['overallShopToken'] != 'undefined' && window.localStorage['overallShopToken'] != '') {
        data.token = window.localStorage['overallShopToken'];
    }
    var res = await axios.request({
        url: '/shop/finance/passRepayment',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return;
    }
    return res;
}
export const refuseRepayment = async (that, data) => {
    if (typeof window.localStorage['overallShopToken'] != 'undefined' && window.localStorage['overallShopToken'] != '') {
        data.token = window.localStorage['overallShopToken'];
    }
    var res = await axios.request({
        url: '/shop/finance/refuseRepayment',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return;
    }
    return res;
}
export const getSalaryList = async (that, data) => {
    if (typeof window.localStorage['overallShopToken'] != 'undefined' && window.localStorage['overallShopToken'] != '') {
        data.token = window.localStorage['overallShopToken'];
    }
    var res = await axios.request({
        url: '/shop/finance/getSalaryList',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return;
    }
    return res;
}

export const saveSalary = async (that, data) => {
    if (typeof window.localStorage['overallShopToken'] != 'undefined' && window.localStorage['overallShopToken'] != '') {
        data.token = window.localStorage['overallShopToken'];
    }
    var res = await axios.request({
        url: '/shop/finance/saveSalary',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return;
    }
    return res;
}

export const getCostList = async (that, data) => {
    if (typeof window.localStorage['overallShopToken'] != 'undefined' && window.localStorage['overallShopToken'] != '') {
        data.token = window.localStorage['overallShopToken'];
    }
    var res = await axios.request({
        url: '/shop/finance/getCostList',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return;
    }
    return res;
}

export const getRechargeList = async (that, data) => {
    if (typeof window.localStorage['overallShopToken'] != 'undefined' && window.localStorage['overallShopToken'] != '') {
        data.token = window.localStorage['overallShopToken'];
    }
    var res = await axios.request({
        url: '/shop/finance/getRechargeList',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return;
    }
    return res;
}
export const getMediumCountList = async (that, data) => {
    if (typeof window.localStorage['overallShopToken'] != 'undefined' && window.localStorage['overallShopToken'] != '') {
        data.token = window.localStorage['overallShopToken'];
    }
    var res = await axios.request({
        url: '/shop/finance/getMediumCountList',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return;
    }
    return res;
}
export const countDownClient = async (that, data) => {
    if (typeof window.localStorage['overallShopToken'] != 'undefined' && window.localStorage['overallShopToken'] != '') {
        data.token = window.localStorage['overallShopToken'];
    }
    var res = await axios.request({
        url: '/shop/finance/countDownClient',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return;
    }
    return res;
}

export const getMediumWithdrawList = async (that, data) => {
    if (typeof window.localStorage['overallShopToken'] != 'undefined' && window.localStorage['overallShopToken'] != '') {
        data.token = window.localStorage['overallShopToken'];
    }
    var res = await axios.request({
        url: '/shop/finance/getMediumWithdrawList',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return;
    }
    return res;
}

export const withdrawSubmit = async (that, data) => {
    if (typeof window.localStorage['overallShopToken'] != 'undefined' && window.localStorage['overallShopToken'] != '') {
        data.token = window.localStorage['overallShopToken'];
    }
    var res = await axios.request({
        url: '/shop/finance/withdrawSubmit',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return;
    }
    return res;
}
export const consumptionReport = async (that, data) => {
    if (typeof window.localStorage['overallShopToken'] != 'undefined' && window.localStorage['overallShopToken'] != '') {
        data.token = window.localStorage['overallShopToken'];
    }
    var res = await axios.request({
        url: '/shop/finance/consumptionReport',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return;
    }
    return res;
}
export const getOtherList = async (that, data) => {
    if (typeof window.localStorage['overallShopToken'] != 'undefined' && window.localStorage['overallShopToken'] != '') {
        data.token = window.localStorage['overallShopToken'];
    }
    var res = await axios.request({
        url: '/shop/finance/getOtherList',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return;
    }
    return res;
}
export const saveExpenditure = async (that, data) => {
    if (typeof window.localStorage['overallShopToken'] != 'undefined' && window.localStorage['overallShopToken'] != '') {
        data.token = window.localStorage['overallShopToken'];
    }
    var res = await axios.request({
        url: '/shop/finance/saveExpenditure',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return;
    }
    return res;
}
export const saveExpenditureStatus = async (that, data) => {
    if (typeof window.localStorage['overallShopToken'] != 'undefined' && window.localStorage['overallShopToken'] != '') {
        data.token = window.localStorage['overallShopToken'];
    }
    var res = await axios.request({
        url: '/shop/finance/saveExpenditureStatus',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return;
    }
    return res;
}
export const getEarningsStatement = async (that, data) => {
    if (typeof window.localStorage['overallShopToken'] != 'undefined' && window.localStorage['overallShopToken'] != '') {
        data.token = window.localStorage['overallShopToken'];
    }
    var res = await axios.request({
        url: '/shop/finance/getEarningsStatement',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return;
    }
    return res;
}

export const getNewCostList = async (that, data) => {
    if (typeof window.localStorage['overallShopToken'] != 'undefined' && window.localStorage['overallShopToken'] != '') {
        data.token = window.localStorage['overallShopToken'];
    }
    var res = await axios.request({
        url: '/shop/finance/getNewCostList',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return;
    }
    return res;
}

export const getClientIdList = async (that, data) => {
    if (typeof window.localStorage['overallShopToken'] != 'undefined' && window.localStorage['overallShopToken'] != '') {
        data.token = window.localStorage['overallShopToken'];
    }
    var res = await axios.request({
        url: '/shop/finance/getClientIdList',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return;
    }
    return res;
}

export const addRecharge = async (that, data) => {
    if (typeof window.localStorage['overallShopToken'] != 'undefined' && window.localStorage['overallShopToken'] != '') {
        data.token = window.localStorage['overallShopToken'];
    }
    var res = await axios.request({
        url: '/shop/finance/addRecharge',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return;
    }
    return res;
}
export const getRecharge = async (that, data) => {
    if (typeof window.localStorage['overallShopToken'] != 'undefined' && window.localStorage['overallShopToken'] != '') {
        data.token = window.localStorage['overallShopToken'];
    }
    var res = await axios.request({
        url: '/shop/finance/getRecharge',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return;
    }
    return res;
}
export const delRecharge = async (that, data) => {
    if (typeof window.localStorage['overallShopToken'] != 'undefined' && window.localStorage['overallShopToken'] != '') {
        data.token = window.localStorage['overallShopToken'];
    }
    var res = await axios.request({
        url: '/shop/finance/delRecharge',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return;
    }
    return res;
}
export const passRecharge = async (that, data) => {
    if (typeof window.localStorage['overallShopToken'] != 'undefined' && window.localStorage['overallShopToken'] != '') {
        data.token = window.localStorage['overallShopToken'];
    }
    var res = await axios.request({
        url: '/shop/finance/passRecharge',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return;
    }
    return res;
}
export const refuseRecharge = async (that, data) => {
    if (typeof window.localStorage['overallShopToken'] != 'undefined' && window.localStorage['overallShopToken'] != '') {
        data.token = window.localStorage['overallShopToken'];
    }
    var res = await axios.request({
        url: '/shop/finance/refuseRecharge',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return;
    }
    return res;
}
export const getBalanceData = async (that, data) => {
    if (typeof window.localStorage['overallShopToken'] != 'undefined' && window.localStorage['overallShopToken'] != '') {
        data.token = window.localStorage['overallShopToken'];
    }
    var res = await axios.request({
        url: '/shop/finance/getBalanceData',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return;
    }
    return res;
}
export const getBalance = async (that, data) => {
    if (typeof window.localStorage['overallShopToken'] != 'undefined' && window.localStorage['overallShopToken'] != '') {
        data.token = window.localStorage['overallShopToken'];
    }
    var res = await axios.request({
        url: '/shop/finance/getBalance',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return;
    }
    return res;
}

export const getDayCostList = async (that, data) => {
    if (typeof window.localStorage['overallShopToken'] != 'undefined' && window.localStorage['overallShopToken'] != '') {
        data.token = window.localStorage['overallShopToken'];
    }
    var res = await axios.request({
        url: '/shop/finance/getDayCostList',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return;
    }
    return res;
}

